import React from 'react';
import styled from 'styled-components';

import { media } from '../../styles/breakpoints';

const Container = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;

    ${media.md} {
        padding: 0 15px;
    }

    ${media.sm} {
        padding: 0 10px;
    }
`;

const PageContainer = ({ children }) => {
    return <Container>{children}</Container>;
};

export default PageContainer;